import React, { useState } from 'react';
import Draggable from 'react-draggable';


const Beads = ({ size, onStop, src }) => {
  const [moved, setMoved] = useState(false);

  const handleStopped = (e, data) => {
    // Only call onStop once
    !moved && onStop && onStop();
    setMoved(true);
  };

  return (
    <Draggable onStop={handleStopped}>
      <div className={`nums nums-${size} ${moved ? 'moved' : ''}`}>
        <img alt= {`nums-${size}`} src={src} ></img>
      </div>
    </Draggable>
  );
};

export default Beads;
